<template>
  <div class="watchCenterPage">
    <leftNav :navarr="navarr" />
    <div class="main-center">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import leftNav from "../../components/leftNav";

export default {
  name: "watchCenterPage",
  data() {
    return {
      navarr: [
        { name: "用电告警", icon: require("@/assets/leftnav/electric.png") },
        { name: "环境告警", icon: require("@/assets/leftnav/env.png") },
        { name: "隐患预警", icon: require("@/assets/leftnav/preHiddle.png") },
      ],
    };
  },
  methods: {},
  mounted() {
    let that=this
  console.log(this.$route)
    // this.$nextTick(() => {
    //   if(that.$route.path=='/hiddenWarn'){
    //     that.navarr=[
    //       { name: "用电告警", icon: require("@/assets/leftnav/electric.png") },
    //       { name: "环境告警", icon: require("@/assets/leftnav/env.png") },
    //       { name: "隐患预警", icon: require("@/assets/leftnav/preHiddle.png") },
    //     ]
    //     that.navarr[2].firshow=true
    //   }else{
    //     that.navarr=[
    //       { name: "用电告警", icon: require("@/assets/leftnav/electric.png") },
    //       { name: "环境告警", icon: require("@/assets/leftnav/env.png") },
    //       { name: "隐患预警", icon: require("@/assets/leftnav/preHiddle.png") },
    //     ]
    //   }
    // })

  },
  watch: {},
  components: {
    leftNav,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.watchCenterPage {
  height: 100%;
  overflow: auto;
}
.main-center {
  width: calc(100% - 240px);
  height: 100%;
  display: inline-block;
  vertical-align: top;
  background-color: #ecf0f6;
  padding: 20px 24px;
  overflow: auto;
}
</style>
